import styled from 'styled-components'

interface Cyber_wrapper_Props {
  showLoader?: boolean
}
export const CyberWrapper = styled.div<Cyber_wrapper_Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  transform: ${({ showLoader }) => (showLoader ? 'scale(0.8)' : 'scale(1)')};
  transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
`
